import { useEffect } from "react";
import { Link as RemixLink } from "@remix-run/react";

import {
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  Button,
  Box,
} from "@chakra-ui/react";

import { ArrowForwardIcon as UpgradeIcon } from "@chakra-ui/icons";
import { getOfferCopy } from "#app/config/freeAccessOffers.js";

import { FreeAccessAlertShell } from "./FreeAccessAlertShell.jsx";
import { capturePostHog } from "#app/utils/posthog.client.js";

export function AvailabilityRequestFormTrialAlert({ mode, ...rest }) {
  // This alert only renders when the user is out of trial notifications, so its
  // mount IS the in-form paywall impression — the bridge from trial-exhaustion
  // to checkout.
  useEffect(() => {
    capturePostHog("paywall_viewed", { location: "request_form", mode });
  }, [mode]);

  return (
    <Alert
      status="warning"
      variant="top-accent"
      {...rest}
      data-testid="request-form-trial-alert"
    >
      <AlertIcon />
      <Box flexGrow={1}>
        <AlertTitle>You won't receive notifications</AlertTitle>
        <AlertDescription>
          You can {mode} this request, but you need to subscribe to receive
          notifications.{" "}
          <Button
            variant="link"
            colorScheme="black"
            rightIcon={<UpgradeIcon />}
            as={RemixLink}
            to="/subscribe"
          >
            Upgrade now
          </Button>
        </AlertDescription>
      </Box>
    </Alert>
  );
}

export function AvailabilityRequestFormFreeAccessAlert({ offer, ...rest }) {
  const copy = getOfferCopy(offer);
  if (!copy) return null;

  return (
    <FreeAccessAlertShell
      headline={copy.headline}
      body={copy.body}
      data-testid="request-form-free-access-alert"
      {...rest}
    />
  );
}
